import { ActionContext, Module } from 'vuex'
import { RootState } from '../..'

export type ConfigState = {
  BASE_FEEDS_URL: string;
  YACHT_TRACKER_WIDTH: string;
  YACHT_TRACKER_HEIGHT: string;
  YACHT_TRACKER_CENTER_LON: number;
  YACHT_TRACKER_CENTER_LAT: number;
  YACHT_TRACKER_ZOOM: number;
  YACHT_TRACKER_IS_PRERACE: string;
  YACHT_TRACKER_IS_LIVE_RACE: string;
  YACHT_TRACKER_RACE_NAME: string;
  YACHT_TRACKER_RACE_YEAR: string;
  YACHT_TRACKER_RACE_ID: number;
  YACHT_TRACKER_RACETIME_MIN: string;
  YACHT_TRACKER_RACETIME_MAX: string;
  LIVE_TRACKER_CENTER_LON: number;
  LIVE_TRACKER_CENTER_LAT: number;
  LIVE_TRACKER_ZOOM: number;
  LIVE_TRACKER_PITCH: number;
  LIVE_TRACKER_BEARING: number;
  DEBUG_MODE: string;
}

function getInitialState (): ConfigState {
  return {
    BASE_FEEDS_URL: '',
    YACHT_TRACKER_WIDTH: '',
    YACHT_TRACKER_HEIGHT: '',
    YACHT_TRACKER_CENTER_LON: 0,
    YACHT_TRACKER_CENTER_LAT: 0,
    YACHT_TRACKER_ZOOM: 0,
    YACHT_TRACKER_IS_PRERACE: '',
    YACHT_TRACKER_IS_LIVE_RACE: '',
    YACHT_TRACKER_RACE_NAME: '',
    YACHT_TRACKER_RACE_YEAR: '',
    YACHT_TRACKER_RACE_ID: 0,
    YACHT_TRACKER_RACETIME_MIN: '',
    YACHT_TRACKER_RACETIME_MAX: '',
    LIVE_TRACKER_CENTER_LON: 0,
    LIVE_TRACKER_CENTER_LAT: 0,
    LIVE_TRACKER_ZOOM: 0,
    LIVE_TRACKER_PITCH: 0,
    LIVE_TRACKER_BEARING: 0,
    DEBUG_MODE: ''
  }
}

const configModule: Module<ConfigState, RootState> = {
  namespaced: true,
  state: (): ConfigState => getInitialState(),
  actions: {
    init (context: ActionContext<ConfigState, RootState>): Promise<void> {
      const config = {
        BASE_FEEDS_URL: window.BASE_FEEDS_URL,
        YACHT_TRACKER_WIDTH: window.YACHT_TRACKER_WIDTH,
        YACHT_TRACKER_HEIGHT: window.YACHT_TRACKER_HEIGHT,
        YACHT_TRACKER_CENTER_LON: window.YACHT_TRACKER_CENTER_LON,
        YACHT_TRACKER_CENTER_LAT: window.YACHT_TRACKER_CENTER_LAT,
        YACHT_TRACKER_ZOOM: window.YACHT_TRACKER_ZOOM,
        YACHT_TRACKER_IS_PRERACE: window.YACHT_TRACKER_IS_PRERACE,
        YACHT_TRACKER_IS_LIVE_RACE: window.YACHT_TRACKER_IS_LIVE_RACE,
        YACHT_TRACKER_RACE_NAME: window.YACHT_TRACKER_RACE_NAME,
        YACHT_TRACKER_RACE_YEAR: window.YACHT_TRACKER_RACE_YEAR,
        YACHT_TRACKER_RACE_ID: window.YACHT_TRACKER_RACE_ID,
        YACHT_TRACKER_RACETIME_MIN: window.YACHT_TRACKER_RACETIME_MIN,
        YACHT_TRACKER_RACETIME_MAX: window.YACHT_TRACKER_RACETIME_MAX,
        LIVE_TRACKER_CENTER_LON: window.LIVE_TRACKER_CENTER_LON,
        LIVE_TRACKER_CENTER_LAT: window.LIVE_TRACKER_CENTER_LAT,
        LIVE_TRACKER_ZOOM: window.LIVE_TRACKER_ZOOM,
        LIVE_TRACKER_PITCH: window.LIVE_TRACKER_PITCH,
        LIVE_TRACKER_BEARING: window.LIVE_TRACKER_BEARING,
        DEBUG_MODE: window.DEBUG_MODE
      }

      return new Promise(resolve => {
        context.commit('SET_CONFIG', config)
        resolve()
      })
    },
    reset (context: ActionContext<ConfigState, RootState>): void {
      context.commit('RESET_STATE')
    }
  },
  mutations: {
    SET_CONFIG (state: ConfigState, payload: ConfigState): void {
      state.BASE_FEEDS_URL = payload.BASE_FEEDS_URL
      state.YACHT_TRACKER_WIDTH = payload.YACHT_TRACKER_WIDTH
      state.YACHT_TRACKER_HEIGHT = payload.YACHT_TRACKER_HEIGHT
      state.YACHT_TRACKER_CENTER_LON = payload.YACHT_TRACKER_CENTER_LON
      state.YACHT_TRACKER_CENTER_LAT = payload.YACHT_TRACKER_CENTER_LAT
      state.YACHT_TRACKER_ZOOM = payload.YACHT_TRACKER_ZOOM
      state.YACHT_TRACKER_IS_PRERACE = payload.YACHT_TRACKER_IS_PRERACE
      state.YACHT_TRACKER_IS_LIVE_RACE = payload.YACHT_TRACKER_IS_LIVE_RACE
      state.YACHT_TRACKER_RACE_NAME = payload.YACHT_TRACKER_RACE_NAME
      state.YACHT_TRACKER_RACE_YEAR = payload.YACHT_TRACKER_RACE_YEAR
      state.YACHT_TRACKER_RACE_ID = payload.YACHT_TRACKER_RACE_ID
      state.YACHT_TRACKER_RACETIME_MIN = payload.YACHT_TRACKER_RACETIME_MIN
      state.YACHT_TRACKER_RACETIME_MAX = payload.YACHT_TRACKER_RACETIME_MAX
      state.LIVE_TRACKER_CENTER_LON = payload.LIVE_TRACKER_CENTER_LON
      state.LIVE_TRACKER_CENTER_LAT = payload.LIVE_TRACKER_CENTER_LAT
      state.LIVE_TRACKER_ZOOM = payload.LIVE_TRACKER_ZOOM
      state.LIVE_TRACKER_PITCH = payload.LIVE_TRACKER_PITCH
      state.LIVE_TRACKER_BEARING = payload.LIVE_TRACKER_BEARING
      state.DEBUG_MODE = payload.DEBUG_MODE
    },
    RESET_STATE (state: ConfigState) {
      state = getInitialState()
    }
  }
}

export default configModule
